import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import AdminLayout from 'layout/Admin';
import { Navigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const AdminRestaurants = Loadable(lazy(() => import('pages/admin/restaurants')));
const AdminRestaurantDetails = Loadable(lazy(() => import('pages/admin/restaurant-details')));
const AdminSettings = Loadable(lazy(() => import('pages/admin/settings')));
const AdminChangePassword = Loadable(lazy(() => import('pages/admin/change-password')));
const AdminComments = Loadable(lazy(() => import('pages/admin/comments')));

// Restaurant details tabs
const AdminRestaurantWorkers = Loadable(lazy(() => import('pages/admin/restaurant-details/workers')));
const AdminRestaurantReservations = Loadable(lazy(() => import('pages/admin/restaurant-details/reservations')));
const AdminRestaurantRequests = Loadable(lazy(() => import('pages/admin/restaurant-details/requests')));
const AdminCustomerRequests = Loadable(lazy(() => import('pages/admin/restaurant-details/customer-requests')));
const AdminRestaurantShifts = Loadable(lazy(() => import('pages/admin/restaurant-details/shifts')));
const AdminRestaurantTableCoverage = Loadable(lazy(() => import('pages/admin/restaurant-details/table-coverage')));
const AdminRestaurantComments = Loadable(lazy(() => import('pages/admin/restaurant-details/comments')));
const AdminRestaurantQRCodes = Loadable(lazy(() => import('pages/admin/restaurant-details/qr-codes')));

// Worker details
const WorkerDetails = Loadable(lazy(() => import('pages/admin/restaurant-details/worker-details')));
const WorkerProfile = Loadable(lazy(() => import('pages/admin/restaurant-details/worker-details/profile')));
const WorkerReviews = Loadable(lazy(() => import('pages/admin/restaurant-details/worker-details/reviews')));
// const WorkerRequests = Loadable(lazy(() => import('pages/admin/restaurant-details/worker-details/requests')));

// ==============================|| RESTAURANT ROUTING ||============================== //

const RestaurantRoutes = {
  path: '/admin',
  children: [
    {
      path: '/admin/',
      element: <AdminLayout onlySpanish />,
      children: [
        {
          index: true,
          element: <Navigate to="restaurants" replace />
        },
        {
          path: 'restaurants',
          element: <AdminRestaurants />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'comments',
          element: <AdminComments />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'restaurants/:id',
          element: <AdminRestaurantDetails />,
          errorElement: <ErrorBoundary />,
          children: [
            {
              index: true,
              element: <Navigate to="workers" replace />
            },
            {
              path: 'workers',
              element: <AdminRestaurantWorkers />,
              errorElement: <ErrorBoundary />,
              children: [
                {
                  path: ':workerId',
                  element: <WorkerDetails />,
                  errorElement: <ErrorBoundary />,
                  children: [
                    {
                      path: 'profile',
                      element: <WorkerProfile />,
                      errorElement: <ErrorBoundary />
                    },
                    {
                      path: 'reviews',
                      element: <WorkerReviews />,
                      errorElement: <ErrorBoundary />
                    }
                    // {
                    //   path: 'requests',
                    //   element: <WorkerRequests />,
                    //   errorElement: <ErrorBoundary />
                    // }
                  ]
                }
              ]
            },
            {
              path: 'reservations',
              element: <AdminRestaurantReservations />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'requests',
              element: <AdminRestaurantRequests />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'customer-requests',
              element: <AdminCustomerRequests />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'shifts',
              element: <AdminRestaurantShifts />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'table-coverage',
              element: <AdminRestaurantTableCoverage />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'comments',
              element: <AdminRestaurantComments />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'qr-codes',
              element: <AdminRestaurantQRCodes />,
              errorElement: <ErrorBoundary />
            }
          ]
        },
        {
          path: 'settings',
          children: [
            {
              index: true,
              element: <AdminSettings />,
              errorElement: <ErrorBoundary />
            },
            {
              path: 'change-password',
              element: <AdminChangePassword />,
              errorElement: <ErrorBoundary />
            }
          ]
        }
      ]
    }
  ]
};

export default RestaurantRoutes;
